<template>
  <div
    id="two-block"
    class="two-block-section"
  >
    <div class="container">
      <div class="row">
        <div class="col-6 orange">
          <h1
            class="title"
            v-html="section.left_title"
          />
          <div
            class="content"
            v-html="section.left_content"
          />
          <div
            class="disclaimer"
            v-html="section.left_disclaimer"
          />
        </div>
        <div class="col-6 grey">
          <h1
            class="title"
            v-html="section.right_title"
          />
          <div
            class="content"
            v-html="section.right_content"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import stripBlockTags from '@/utils/strip-block-tags';

export default {
  name: 'BannerLikeSection',

  props: {
    section: { type: Object, required: true }
  },

  methods: {
    stripBlockTags
  }
};
</script>

<style lang="scss" scoped>
.two-block-section {
  background-image: none;
  padding: 0;
  margin-top: 40px;

  @media screen and (min-width: $breakpoint-md) {
    background-image: linear-gradient(to right, $thd-orange 45%, #efefef 45%);
  }

  .container {
    max-width: 100%;
    padding-top: 40px !important;
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0 !important;

    @media screen and (min-width: $breakpoint-md) {
      max-width: 1120px;
      padding-left: 24px;
      padding-right: 24px;
      padding-bottom: 30px !important;
    }
  }

  .row {
    margin-left: 0;
    margin-right: 0;

    .col-6 {
      margin: 0;
      width: 100%;

      @media screen and (min-width: $breakpoint-md) {
        width: 50%;
      }
    }

    .orange {
      color: $thd-white;
      background-color: #f96302;
      padding: 20px 24px;

      @media screen and (min-width: $breakpoint-md) {
        background-color: unset;
        padding: 0;
      }

      .content {
        color: $thd-white;
        font-size: 24px;

        strong {
          color: $thd-white;
          font-size: 24px;
        }
      }

      .disclaimer {
        margin-top: 20px;
      }
    }

    .grey {
      color: $thd-black;
      background-color: #efefef;
      padding: 20px 24px;

      @media screen and (min-width: $breakpoint-md) {
        background-color: unset;
        padding: 0;
      }

      .content {
        color: $thd-black;
        font-size: 20px;
        line-height: normal;
      }
    }

    h1 {
      font-size: 2.8em;
      margin-top: 0;
    }
  }
}
</style>
